// Los ponderadores de los reajustes pueden llegar como número (los que vienen de la base) o como texto (los que se
// acaban de escribir en un JqxNumberInput, por ejemplo "60.00"). Sumarlos con «+» concatena los textos y la suma deja
// de ser un número: con 60 % + 40 % el formulario avisaba «Ponderaciones de los índices superan el 100%.» aunque el
// total fuera exactamente 100. Estas funciones convierten siempre a número y redondean a 6 decimales para no arrastrar
// errores de coma flotante.
const roundTo6 = (value) => Math.round(value * 1e6) / 1e6;

// Vacío (null, undefined, '') cuenta como 0; un texto que no es número da NaN, y así la validación lo rechaza.
const toNumber = (value) => (value === null || value === undefined || value === '' ? 0 : Number(value));

export const sumPonderadores = (list) =>
    roundTo6((list ?? []).reduce((total, item) => total + toNumber(item?.ponderador), 0));

// true si la suma de la lista más el valor nuevo no pasa del límite (100 por defecto).
export const isPonderadorSumWithinLimit = (list, newValue, limit = 100) =>
    roundTo6(sumPonderadores(list) + toNumber(newValue)) <= limit;

// Lo que falta para llegar a 100 (el «No reajustable»). null si la lista no existe (undefined).
export const missingPonderador = (list) => (list === undefined ? null : roundTo6(100 - sumPonderadores(list)));
